export default __webpack_public_path__ + "static/media/audio-response.9b608ab5.svg";